// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyArjO8QuS5TfLkQmedGT_yNzHrIblWFGwk",
  authDomain: "nuance-radio-307ee.firebaseapp.com",
  projectId: "nuance-radio-307ee",
  appId: "1:225049358153:web:YOUR_APP_ID", // Replace with your actual App ID if needed
  // ...other config values as needed
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app); 